// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";

function BackButtonComponent(Props) {
  var classNameOpt = Props.className;
  var textOpt = Props.text;
  var onClickOpt = Props.onClick;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var text = textOpt !== undefined ? textOpt : "<";
  var onClick = onClickOpt !== undefined ? onClickOpt : (function (prim) {
        window.history.back();
        
      });
  return React.createElement("div", {
              className: className
            }, React.createElement("span", {
                  onClick: (function (_event) {
                      return Curry._1(onClick, undefined);
                    })
                }, text));
}

var make = BackButtonComponent;

export {
  make ,
  
}
/* react Not a pure module */
